import { Injectable } from '@angular/core';
import { API } from 'aws-amplify';
import { Observable, from } from 'rxjs';
import { environment } from 'src/environments/environment';

export const DECIDO_EVALUATION_API_NAME: string = 'decido_evaluation';
export const DECIDO_EVALUATION_API_ENDPOINT: string = environment.API_BASE_PATH + '/decido-evaluation';

@Injectable({
  providedIn: 'root',
})
export class DecidoEvaluationService {
  read(decido_evaluation_id: string, buyer_id: string): Observable<any> {
    const api_name: string = DECIDO_EVALUATION_API_NAME;
    const path: string = `/${decido_evaluation_id}/buyer/${buyer_id}`;
    const init = { response: true };
    return from(API.get(api_name, path, init));
  }
}

export class DecidoEvaluation {
  decido_evaluation_id?: string;
  process_id?: string;
  result?: Result;
}

export interface Result {
  result?: string;
  code?: string;
  rating?: string;
  score?: string;
}
